var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"breadcrumbs"},_vm._l((_vm.links),function(link){return _c('li',{key:link.text},[_c('a',{attrs:{"href":link.href}},[_vm._v(_vm._s(link.text))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }